import modalWindow from '@common/modalWindow';

const topDonationsModal = () => {
  modalWindow({
    modalSelector: '#static-modal',
  });
};

export default topDonationsModal;
